{
  "activateFieldAllActiveErrorMessage": "Tutti i campi sono attivi",
  "activateFieldDescription": "Il campo diventerà immediatamente visibile nelle mappe della fattoria.",
  "activateFieldLinkTo": "Attiva campo",
  "activateFieldTitle": "Conferma Attiva Campo",
  "archiveFieldAllArchivedErrorMessage": "Tutti i campi sono archiviati",
  "archiveFieldInstructions": "Il campo verrà nascosto dalle mappe della fattoria e ignorato negli aggiornamenti sulla posizione delle attrezzature. Ciò non avrà alcun impatto sulla raccolta dati; se riattivi il campo, qualsiasi attività sarà immediatamente disponibile.",
  "archiveFieldLinkTo": "Campo di archivio",
  "archiveFieldTitle": "Campo di archivio",
  "archiveFieldsHelpDescription": "I campi archiviati saranno nascosti dalla mappa di stato, ma non saranno eliminati e potranno essere riattivati in qualsiasi momento. Potresti volerlo fare per i campi che non sono in uso durante una determinata stagione.",
  "areaAcresWithVal": "{{val}} acri",
  "confirmDeleteFieldInputLabel": "Inserisci il nome del campo",
  "confirmDeleteFieldInstructions": "Il campo verrà eliminato definitivamente.\n\nQuesta azione non può essere annullata.",
  "confirmDeleteFieldLinkTo": "Elimina campo",
  "confirmDeleteFieldTitle": "Elimina campo",
  "enterFieldName": "Inserisci il nome del campo",
  "fieldArchived": "Questo campo è archiviato.",
  "fieldIrrigationHistoryLinkTo": "Visualizza la cronologia dell'irrigazione",
  "fieldNameInputLabel": "Nome del campo",
  "fieldNameInputPlaceholder": "Come si chiama il campo?",
  "fieldProfileLandingLinkTo": "Profilo del campo",
  "fieldProfileLandingTitle": "Profilo del campo",
  "fieldsRosterHelpDescription": "Visualizza tutti i campi che appartengono a questa farm. Puoi archiviare e attivare i campi qui e anche navigare al profilo di ogni campo cliccando/premendo la scheda campo nell'elenco.",
  "fieldsRosterLinkTo": "Gestisci campi",
  "fieldsRosterListEmpty": "Il tuo account farm non ha campi",
  "fieldsRosterNewFieldButton": "Nuovo campo",
  "fieldsRosterSortKeys": {
    "alphabetical": "Nome del campo",
    "fieldStatus": "Stato del campo"
  },
  "fieldsRosterTitle": "Campi",
  "fieldsRosterTitleWithItemCount": "Campi ({{itemCount}})",
  "setFieldBoundaryInstructions": [
    "Disegna il tuo campo toccando la mappa. Il campo deve avere almeno 3 punti ed essere completamente chiuso.\n\nSe vuoi ricominciare, clicca/premi Ricomincia.\n\nSarai anche in grado di cambiare la forma del campo in seguito, se necessario."
  ],
  "setFieldBoundaryTitle": "Disegna il confine del campo",
  "setFieldLabelRotationDragSliderHint": "Spostare il cursore per regolare la direzione dell'etichetta",
  "setFieldLabelRotationInstructions": "Imposta la rotazione dell'etichetta del campo secondo necessità",
  "setFieldLabelRotationLabel": "Rotazione",
  "setFieldLabelRotationTitle": "Imposta rotazione etichetta",
  "setFieldNameInputLabel": "Nome del campo",
  "setFieldNameInstructions": "Inserisci un nome per il campo",
  "setFieldNameLinkTo": "Modifica etichetta",
  "setFieldNamePlaceholderText": "Come si chiama il campo?",
  "setFieldNameTitle": "Inserisci il nome del campo",
  "setFieldRowDirectionDragSliderHint": "Sposta il cursore per regolare la direzione della riga",
  "setFieldRowDirectionFlipButton": "Capovolgere",
  "setFieldRowDirectionInstructions": "Imposta la direzione della riga del campo",
  "setFieldRowDirectionLinkTo": "Imposta direzione riga",
  "setFieldRowDirectionTitle": "Imposta direzione riga",
  "sortFields": "Ordina campi",
  "updateFieldBoundaryInstructions": "Aggiorna il tuo campo trascinando i punti sulla mappa. Il campo deve avere almeno 3 punti ed essere completamente chiuso.",
  "updateFieldBoundaryTitle": "Disegna il confine del campo"
}
